import React, { useState } from 'react';
import Helmet from 'react-helmet';
import { Inertia } from '@inertiajs/inertia';
import { InertiaLink, usePage } from '@inertiajs/inertia-react';
import AdminLayout from '../../../Shared/AdminLayout';
import DataContainer from '../../../Shared/DataContainer';
import DropdownButton from '../../../Shared/DropdownButton';
import Pagination from '../../../Shared/Pagination';
import Icon from '../../../Shared/Icon';
import { can } from '../../../utils';
import LoadingButton from '../../../Shared/LoadingButton';
import axios from "axios";

const Show = () => {
     const { auth, errors, data } = usePage().props;
     const [sending, setSending] = useState(false);
     const [values, setValues] = useState({});

     function handleSubmit(e) {
          e.preventDefault();
          setSending(true);
          Inertia.post(route('deliveryext.delivered', data.id), values).then(() => {
               setSending(false);
          });
     }

     return (
          <React.Fragment key="purchase-detail">
               <Helmet>
                    <title>Order Details</title>
               </Helmet>
               <div className="max-w-7xl mx-auto p-2">
                    <InertiaLink className="font-semibold text-md text-gray-700 hover:text-gray-800 leading-tight" href={route('home')}>Dashboard</InertiaLink> | <InertiaLink className="font-semibold text-md text-gray-700 hover:text-gray-800 leading-tight" href={route('purchase.index')}>Purchase History</InertiaLink> | <span className="text-md text-gray-700 leading-tight">Order Details</span>
               </div>
               {data && (<React.Fragment key="anfen">
                    <div className="w-full bg-white">
                         <div className="flex flex-col w-full p-8 text-gray-800 mt-2 pin-r pin-y text-sm">
                              {!data.is_delivered && (<div className="flex w-full">
                                   <form onSubmit={handleSubmit}>
                                        <LoadingButton type="submit" loading={sending} className="float-right inline-flex items-center px-4 py-2 bg-gray-700 border border-transparent rounded-md font-semibold text-xs text-gray-100 uppercase tracking-widest hover:bg-gray-500 active:bg-gray-500 focus:outline-none focus:border-gray-500 focus:shadow-outline-gray disabled:opacity-25 transition ease-in-out duration-150 ml-4">
                                             Set Delivered.
                                        </LoadingButton>
                                   </form>
                              </div>)}
                              <div className="flex w-full">
                                   <div className="w-1/2 px-3 py-3">
                                        <div className="font-semibold p-2 bg-gray-100 mt-2 mr-2 text-gray-700">Deliver To <span className="font-semibold float-right text-gray-500">{data.deliveryname}</span></div>
                                        <div className="font-semibold p-2 bg-gray-100 mt-2 text-gray-700">Phone <span className="font-semibold float-right text-gray-500">{data.deliveryphone}</span></div>
                                        <div className="font-semibold p-2 bg-gray-100 mt-2 text-gray-700">Zone <span className="font-semibold float-right text-gray-500">{data.destination}</span></div>
                                   </div>
                                   <div className="w-1/2 px-3 py-3">
                                        <div className="font-semibold p-2 bg-gray-100 mt-2 mr-2 text-gray-700">Date <span className="font-semibold float-right text-gray-500">{data.created}</span></div>
                                        <div className="font-semibold p-2 bg-gray-100 mt-2 mr-2 text-gray-700">Status <span className="font-semibold float-right text-gray-500" style={{color: `#${data.color}`}}>{data.status}</span></div>
                                        <div className="font-semibold p-2 bg-gray-100 mt-2 mr-2 text-gray-700">Address <span className="font-semibold float-right text-gray-500">{data.address}</span></div>
                                   </div>
                              </div>
                         </div>
                         <div className="w-full flex px-8 py-4 bg-white">
                              <table className="table-fixed w-full text-sm">
                                   <thead className="bg-gray-100">
                                        <tr>
                                             <th className="px-4 py-2">Product</th>
                                             <th className="px-4 py-2">Quantity</th>
                                        </tr>
                                   </thead>
                                   <tbody>
                                        {data.details.map(({id, name, type, category, code, quantity, packs, image}) => {
                                             return <tr key={id}>
                                                  <td className="border px-4">
                                                       {name} <span className="text-xs text-gray-500">({code})</span>
                                                       {packs && (<p className="ml-4 text-xs text-gray-600">{packs.join(' | ')}</p>)}
                                                  </td>
                                                  <td className="border px-4 py-2 text-center">{quantity}</td>
                                             </tr>
                                        })}
                                   </tbody>
                              </table>
                         </div>
                    </div>
               </React.Fragment>)}
          </React.Fragment>
     );
};

// Persisten layout
// Docs: https://inertiajs.com/pages#persistent-layouts
Show.layout = page => <AdminLayout children={page} header={'Order Details'} />;

export default Show;
